import { render, staticRenderFns } from "./Guarda.vue?vue&type=template&id=44f6fd59&"
import script from "./Guarda.vue?vue&type=script&lang=js&"
export * from "./Guarda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports